import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatDialogModule } from "@angular/material/dialog";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { TranslateModule } from "@ngx-translate/core";
import { SafePipe } from "@shared/pipes/safe.pipe";
import { ConsentDialogComponent } from "./consent-dialog.component";

const materialModules = [MatDialogModule, MatProgressSpinnerModule, MatButtonModule, MatSnackBarModule];

@NgModule({
  declarations: [ConsentDialogComponent],
  imports: [CommonModule, TranslateModule, SafePipe, ...materialModules],
})
export class ConsentDialogModule {}
